import { render, staticRenderFns } from "./EditRealEstateInformation.vue?vue&type=template&id=6df89934&scoped=true"
import script from "./EditRealEstateInformation.vue?vue&type=script&lang=js"
export * from "./EditRealEstateInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df89934",
  null
  
)

export default component.exports